module.exports = __webpack_public_path__ + "img/bubuia_index.435bf06f.jpg";